const LinguisticSkill = {
 "code" :{
  "_text" : ""
 },
 "level" : {
  "_text" : ""
 }
}

export default LinguisticSkill;
